import React from "react";
import { Home, LogOut } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ParentLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const signOut = async () => { await logout(); navigate("/login"); };
    return <div className="min-h-screen bg-slate-50">
        <header className="border-b border-slate-200 bg-white">
            <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-4 sm:px-8">
                <div><p className="font-display text-lg font-black text-slate-900">Espace parent ASSMBB</p><p className="text-xs text-slate-500">{user?.full_name}</p></div>
                <nav className="flex items-center gap-2">
                    <NavLink to="/parent" end className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100"><Home className="h-4 w-4" /> Mes enfants</NavLink>
                    <button onClick={signOut} className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white"><LogOut className="h-4 w-4" /> Déconnexion</button>
                </nav>
            </div>
        </header>
        <main className="mx-auto max-w-5xl px-4 py-8 sm:px-8"><Outlet /></main>
    </div>;
}
